import InputMask from 'react-input-mask';
import NPPlacesInput from '../../google_map/NPPlacesInput';

const RouteSection = ({
  routes,
  route,
  user,
  handlePickupSelect,
  handleDropoffSelect,
  handleUseMyselfChange,
  handleRouteChange,
  handleRemoveRoute,
}) => {
  return (
    <div key={route.id} className={`mb-3`}>
      <h5 className="d-flex justify-content-between">
        <span>Route {route.id}</span>
        {routes.length > 1 && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger ml-2 px-2 py-1"
            onClick={() => handleRemoveRoute(route.id)}
          >
            <i className="fa fa-times" />
          </button>
        )}
      </h5>
      <div className="mb-3">
        <NPPlacesInput
          placeholder="Pickup Address"
          value={route.origin.address || ''}
          onResultSelected={(address, location) =>
            handlePickupSelect(route.id, address, location)
          }
          uniqueKey={`origin_address_${route.id}`}
        />

        <div className="d-flex mx-2  mt-3 mb-1">
          <div>Contact person for pickup</div>
          <div className="px-4 mx-1">
            <input
              className="form-check-input"
              type="checkbox"
              id={`originUseMyself-${route.id}`}
              checked={route.originUseMyself || false}
              onChange={(e) =>
                handleUseMyselfChange(route.id, true, e.target.checked)
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleUseMyselfChange(route.id, true, !route.originUseMyself);
                }
              }}
            />
            <label
              className="form-check-label"
              htmlFor={`originUseMyself-${route.id}`}
            >
              Customer{' '}
              {user?.first_name && `(${user.first_name} ${user.last_name})`}
            </label>
          </div>
        </div>
        <div className="d-flex gap-2">
          <input
            type="text"
            value={route.origin.contact_name || ''}
            onChange={(e) =>
              handleRouteChange(route.id, 'contact_name', e.target.value, true)
            }
            placeholder="Contact name"
            className="form-control w-50 mr-2"
            // readOnly={route.originUseMyself}
          />

          <InputMask
            className="form-control w-50"
            mask="+1 (999) 999-9999"
            value={route.origin.contact_phone || ''}
            placeholder="Contact phone"
            onChange={(e) => {
              let value = e.target.value;
              value = value.replace(/[^0-9]/g, '');

              if (!value.startsWith('1')) {
                value = '1' + value;
              }

              handleRouteChange(route.id, 'contact_phone', `+${value}`, true);
            }}
            onBlur={(e) => {
              if (!e.target.value || e.target.value === '+1') {
                handleRouteChange(route.id, 'contact_phone', '+1', true);
              }
            }}
          />
        </div>
      </div>

      <NPPlacesInput
        placeholder="Drop-off Address"
        value={route.dropoff.address || ''}
        onResultSelected={(address, location) =>
          handleDropoffSelect(route.id, address, location)
        }
        uniqueKey={`dropoff_address_${route.id}`}
      />

      <div className="d-flex mx-2  mt-3 mb-1">
        <div>Contact person for drop-off</div>
        <div className="px-4 mx-1">
          <input
            className="form-check-input"
            type="checkbox"
            id={`dropoffUseMyself-${route.id}`}
            checked={route.dropoffUseMyself || false}
            onChange={(e) =>
              handleUseMyselfChange(route.id, false, e.target.checked)
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleUseMyselfChange(route.id, false, !route.dropoffUseMyself);
              }
            }}
          />
          <label
            className="form-check-label"
            htmlFor={`dropoffUseMyself-${route.id}`}
          >
            Customer{' '}
            {user?.first_name && `(${user.first_name} ${user.last_name})`}
          </label>
        </div>
      </div>

      <div className="d-flex gap-2">
        <input
          type="text"
          value={route.dropoff.contact_name || ''}
          onChange={(e) =>
            handleRouteChange(route.id, 'contact_name', e.target.value, false)
          }
          placeholder="Contact name"
          className="form-control w-50 mr-1"
        />

        <InputMask
          className="form-control w-50"
          mask="+9 (999) 999-9999"
          value={route.dropoff.contact_phone || ''}
          placeholder="Contact phone"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace(/[^0-9]/g, '');

            if (!value.startsWith('1')) {
              value = '1' + value;
            }

            handleRouteChange(route.id, 'contact_phone', `+${value}`, false);
          }}
          onBlur={(e) => {
            if (!e.target.value || e.target.value === '+1') {
              handleRouteChange(route.id, 'contact_phone', '+1', false);
            }
          }}
          // readOnly={route.dropoffUseMyself}
        />
      </div>
    </div>
  );
};

export default RouteSection;
